const pathToRegex = (path: string): RegExp => {
  const pattern = path.replace(/:[^/]+/g, '[^/]+');
  return new RegExp(`${pattern}($|\\?|#)`);
};

const resolvePathParams = (
  templatePath: string,
  currentPath: string,
): string => {
  const templateParts = templatePath.split('/');
  const currentParts = currentPath.split('/');

  return templateParts
    .map((part, index) => {
      if (part.startsWith(':')) {
        return currentParts[index] || part;
      }
      return part;
    })
    .join('/');
};

export interface BreadcrumbData {
  name: string;
  path?: string;
}

export const getActiveRoute = (routes: RoutesType[]): string => {
  const breadcrumbs = getActiveBreadcrumbs(routes);
  return breadcrumbs[breadcrumbs.length - 1]?.name || 'Policy Pilot';
};

const findRouteByName = (
  routes: RoutesType[],
  name: string,
): RoutesType | undefined => {
  for (const route of routes) {
    if (route.collapse) {
      const found = findRouteByName(route.items || [], name);
      if (found) return found;
    } else if (route.name === name) {
      return route;
    }
  }
  return undefined;
};

const buildParentChain = (
  routes: RoutesType[],
  parentName: string | undefined,
  currentPath: string,
): BreadcrumbData[] => {
  if (!parentName) return [];

  const parentRoute = findRouteByName(routes, parentName);
  if (!parentRoute) return [];

  const ancestors = buildParentChain(routes, parentRoute.parent, currentPath);
  const templatePath = parentRoute.layout + parentRoute.path;
  const resolvedPath = resolvePathParams(templatePath, currentPath);

  return [...ancestors, { name: parentName, path: resolvedPath }];
};

export const getActiveBreadcrumbs = (
  routes: RoutesType[],
): BreadcrumbData[] => {
  const currentPath = window.location.pathname;
  let bestMatch: { items: BreadcrumbData[]; specificity: number } = {
    items: [],
    specificity: 0,
  };

  const checkRoutes = (routeList: RoutesType[]) => {
    for (const route of routeList) {
      if (route.collapse) {
        checkRoutes(route.items || []);
      } else {
        const fullPath = route.layout + route.path;
        const regex = pathToRegex(fullPath);
        if (regex.test(currentPath)) {
          const specificity = fullPath.split('/').length;
          if (specificity > bestMatch.specificity) {
            const parentChain = buildParentChain(
              routes,
              route.parent,
              currentPath,
            );
            const items: BreadcrumbData[] = [
              ...parentChain,
              { name: route.name },
            ];
            bestMatch = { items, specificity };
          }
        }
      }
    }
  };

  checkRoutes(routes);
  return bestMatch.items;
};
